import React from "react";
import Navbar from "./Navbar";
import Register from "./Register";
import Footer from "./Footer";

export default function RegisterFullPage() {
  return (
    <div>
      <Navbar></Navbar>
      <Register></Register>
      <Footer></Footer>
    </div>
  );
}